import React from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { setActiveModule } from "../../../../actions/sideBarActions";

const ModuleCard = ({ eachModule }) => {
    const dispatch = useDispatch();

    const getFormattedLists = (lists) => {
        const arr = lists.split("<>");
        // arr.map((str, idx) => {});
        // return;
    };
    const handleModule = (newModule) => {
        localStorage.setItem("activeModule", newModule);
        dispatch(setActiveModule(newModule));
    };
    return (
        <div className="card__container">
            <div className="module__heading__container">
                <img className="module__icon" alt="" src={eachModule.icon} />
                <p className="module__name">{eachModule.heading}</p>
            </div>
            {eachModule.points}
            {/* <ul className="list__content">
                {eachModule.points.map((list, key) => (
                    <>
                        <li className="list__items" key={key}>
                            {list}
                        </li>
                    </>
                ))}
            </ul> */}
            <Link to={eachModule.link} className="bottom__link">
                <span onClick={() => handleModule(eachModule.heading)} className="know__more__link">
                    {"Let's Go >"}
                </span>
            </Link>
        </div>
    );
};

export default ModuleCard;
